import r from "react";
import { parseClassNames as i } from "@ddg-frontend/fe-essentials";
const d = (s) => {
  var a;
  const {
    hyperlink: e,
    linkBuilder: l,
    // needs to be bound on first 2 args .bind(null, "content" | "context", item)
    fakeLinks: n,
    refProp: c,
    ...o
  } = s, t = Object.assign(
    { ...e.attributes },
    {
      ref: c,
      target: e.target ? e.target : "",
      href: e.url ? e.url : "",
      rel: e.rel ? e.rel : ((a = e.target) == null ? void 0 : a.toLowerCase()) === "_blank" ? "noopener noreferrer" : null,
      disabled: !!e.disabled,
      onClick: e.onClick ? e.onClick : null,
      className: i([
        e.styles,
        e.format,
        e.color,
        e.disabled && "btn-inactive"
      ]),
      children: e.text ? /* @__PURE__ */ r.createElement(r.Fragment, null, e.text, e.textAcess && /* @__PURE__ */ r.createElement("span", { className: "screen-readers-only" }, ` ${e.textAcess}`)) : ""
    },
    l ? l(e) : {},
    o
  );
  return n ? /* @__PURE__ */ r.createElement("span", { className: t.className }, t.children) : /* @__PURE__ */ r.createElement("a", { ...t }, t.children);
};
export {
  d as SetLink
};
